export { default } from '../old-button/button';
export type { ButtonProps } from '../old-button/button';
